import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'di-grid-error-row-renderer',
  templateUrl: './grid-error-row-renderer.component.html',
  host: {
    class: 'tw:block tw:bg-red-100 tw:py-2.5 tw:pl-2.5 tw:text-red-800',
  },
  standalone: false,
})
export class GridErrorRowRendererComponent implements ICellRendererAngularComp {
  errorMessage: string;
  params: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;

    this.setErrorMessage();
  }

  refresh(): boolean {
    this.setErrorMessage();

    return false;
  }

  private setErrorMessage(): void {
    this.errorMessage = this.params.data.error;
  }
}
